import { CircularProgress, PaperProps } from '@mui/material';
import { useAdminClaimQuery } from '../../../../api/gql';
import { AdminScenarioInfoBox } from '../../../../modules/scenarios/ScenarioDetailOverview';

type Props = {
  claimId: string;
} & PaperProps;

export const ClaimScenarioInfoBox = ({ claimId }: Props) => {
  const { data, isLoading } = useAdminClaimQuery({ id: claimId });

  if (isLoading) {
    return <CircularProgress />;
  }

  return data?.adminInvoice.scenario?.id ? <AdminScenarioInfoBox scenarioId={data?.adminInvoice.scenario?.id} /> : null;
};
